module.exports = __webpack_public_path__ + "static/media/la-cover.d6be02ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-cover.jpg
// module id = 104
// module chunks = 51